import { type ComponentPropsWithoutRef, type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'clsx';
import { IconShortcutAccountStatementsOutlined } from '@repo/monochrome-icons';
import { useMedia } from 'receivable-invoices-js/react/hooks/use-media';
import { ClientPortalButton } from 'receivable-invoices-js/react/components/shared/responsive-view/client-portal-button';
import styles from './actions.module.css';

interface QuoteActionsProps extends ComponentPropsWithoutRef<'div'> {
  pdfUrl?: string;
  onDownloadClick?: () => void;
  clientPortalId?: string;
  isClientPortalEnabled?: boolean;
}

export function QuoteActions({
  pdfUrl,
  onDownloadClick,
  className,
  clientPortalId,
  isClientPortalEnabled,
  ...props
}: QuoteActionsProps): ReactNode {
  const { isMobile } = useMedia();

  const handleDownloadClick = (): void => {
    if (onDownloadClick) {
      onDownloadClick();
    }
  };

  return (
    <div className={cx(styles.actions, className)} {...props}>
      <a
        className="btn btn--primary"
        data-test-quote-actions-download
        href={pdfUrl}
        onClick={handleDownloadClick}
        rel="noopener noreferrer"
        target="_blank"
        type="button"
      >
        <IconShortcutAccountStatementsOutlined className="mr-8" />
        <FormattedMessage id="quote.preview.cta.download" />
      </a>
      {isClientPortalEnabled && isMobile ? (
        <ClientPortalButton clientPortalId={clientPortalId} />
      ) : null}
    </div>
  );
}
